import t from "./_baseAssignValue.js";
import u from "./_baseForOwn.js";
import m from "./_baseIteratee.js";
var b = t, f = u, l = m;
function p(e, a) {
  var r = {};
  return a = l(a), f(e, function(o, s, n) {
    b(r, s, a(o, s, n));
  }), r;
}
var v = p;
export {
  v as default
};
//# sourceMappingURL=mapValues.js.map
